import { useContext } from 'react';
import { AuthContext, type AuthState } from './AuthProvider';

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth ต้องอยู่ภายใต้ <AuthProvider>');
  }
  return context;
}
